import abstractModel from '../../core/MercatelyModel';

const BASE_URL = `${ENV.DEAL_ENGINE_BASE_URL}`
const RESOURCE = `${BASE_URL}/deals/`;

const model = abstractModel(RESOURCE);

model.getCustomerDeals = async (customerId) => {
  const newResource = `${RESOURCE}customer_deals/${customerId}`;
  return model.get({}, { path: newResource });
};

export default model;
